<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    type="turnaround"
  >
    <template v-slot:toolbar-right>
      <TurnaroundCreateButton />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import InputTableContainer from '@/components/InputTableContainer'
import TurnaroundCreateButton from './TurnaroundCreateButton'
import TurnaroundEditModal from './TurnaroundEditModal'
import TurnaroundDeleteModal from './TurnaroundDeleteModal'

export default {
  name: 'TurnaroundContainer',

  components: {
    InputTableContainer,
    TurnaroundCreateButton
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: TurnaroundEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: TurnaroundDeleteModal,
        type: 'delete'
      }
    ],
    sortBy: ['train_number_from', 'train_number_to', 'location'],
    headers: [
      {
        text: 'Tågnummer från',
        value: 'train_number_from'
      },
      {
        text: 'Tågnummer till',
        value: 'train_number_to'
      },
      {
        text: 'Plats',
        value: 'location'
      },

      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    turnarounds: get('turnaround/data'),
    stops: get('event/stops'),

    data() {
      return Object.values(this.turnarounds).map(x => ({
        ...x,
        _location: this.stops.find(y => y.short_name === x.location).stop_name
      }))
    }
  },

  beforeDestroy() {
    this.$store.set('turnaround/data', {})
  }
}
</script>
